import { render, staticRenderFns } from "./ExploreReportCard.vue?vue&type=template&id=c27ff010&scoped=true"
import script from "./ExploreReportCard.vue?vue&type=script&lang=ts"
export * from "./ExploreReportCard.vue?vue&type=script&lang=ts"
import style0 from "./ExploreReportCard.vue?vue&type=style&index=0&id=c27ff010&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27ff010",
  null
  
)

export default component.exports